<template>
  <div class="site container-fluid px-0">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div class="error-container">
      <div v-if="!isLoading">
        <div class="error-content text-center">
          <div class="row m-0">
            <div class="col-lg-4 image-col">
              <transition name="bounce" enter-active-class="bounceInLeft">
                <img v-if="showWithDelay" :src="logoUrl" alt="error" />
              </transition>
            </div>
            <transition name="bounce" enter-active-class="bounceInRight">
              <div v-if="showWithDelay" class="col-lg-8 text-col text-md-left">
                <h1>Oops...</h1>
                <h1 class="pt-0">{{ errorName }}.</h1>
                <p>{{ errorDescription }}</p>
                <a class="error-btn px-3" @click="navigateHome()" role="link"
                  >GO TO AUTODESK ONE HOME</a
                >
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay";
export default {
  props: {
    errorName: {
      type: String,
      default: "Generic error"
    },
    errorDescription: {
      type: String,
      default: "Error occurred"
    },
    logoUrl: {
      type: String,
      default: "../assets/image/error_pages/401.png"
    }
  },
  name: "error",
  data() {
    return {
      appEnv: CURRENT_ENV,
      isLoading: true,
      showWithDelay: false
    };
  },
  created() {
    document.title = "Error - " + this.errorName + " - Autodesk One";
  },
  mounted() {
    this.isLoading = false;
    setTimeout(() => {
      this.showWithDelay = true;
    }, 500);
  },

  methods: {},
  components: {
    LoadingOverlay
  }
};
</script>
<style scoped>
.site {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}

.image-col {
  border-right: #000 1px solid;
}
.text-col {
  padding-left: 50px;
}
.error-content {
  max-width: 800px;
  display: block;
  margin: auto;
  padding-top: 10%;
}
.error-container h1 {
  font-size: 2.2rem;
}
.error-text-title {
  padding-top: 20px;
}
.error-btn {
  color: var(--secondary-color) !important;
  font-weight: bold;
  padding: 15px;
  border: 1px solid var(--secondary-color);
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 68px;
  position: relative;
  display: inline-block;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 6px;
  margin: 6px 8px;
  line-height: 36px;
  min-height: 36px;
  background: 0 0;
  white-space: nowrap;
  min-width: 88px;
  text-align: center;
  text-transform: uppercase;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  overflow: hidden;
}
.error-btn:hover {
  opacity: 0.9;
  background-color: var(--secondary-color) !important;
  color: #ffffff !important;
}
@media (max-width: 992px) {
  .image-col {
    border-right: none;
  }
}

footer {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorPageWithHeader.vue